const BrandMark = ({ size = 36, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    aria-hidden="true"
    data-testid="brand-mark"
  >
    <rect width="64" height="64" rx="8" fill="#C85A32" />
    <text
      x="30"
      y="45"
      textAnchor="middle"
      fontFamily="Georgia, 'Times New Roman', serif"
      fontSize="38"
      fontWeight="700"
      fill="#F9F8F5"
    >
      O
    </text>
    <circle cx="47" cy="43" r="4" fill="#121314" />
  </svg>
);

const BrandLogo = ({ dark = false }) => (
  <span className="flex items-center gap-3 text-left">
    <BrandMark size={36} />
    <span className="leading-tight">
      <span
        className={`block font-display text-lg font-semibold tracking-wide ${
          dark ? "text-bone" : "text-charcoal"
        }`}
      >
        Obras Martinez
      </span>
      <span
        className={`block font-mono text-[9px] uppercase tracking-[0.28em] ${
          dark ? "text-stone-400" : "text-stone-500"
        }`}
      >
        Reformas · Electricidad
      </span>
    </span>
  </span>
);

export { BrandMark, BrandLogo };
